
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>details</mat-icon>
    </span>
     Memory Card Details
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  
 <mat-dialog-content class="details-content">

  <!-- Memory Card Name -->
  <div class="memory-card-row">
    <span class="label">Memory Card Name</span>
    <span class="value">{{ memoryCardName }}</span>
  </div>

  <!-- Description -->
  <div class="description-section">
    <div class="description-header">
      Description
    </div>

    <div class="description-body">
      <pre>{{ description }}</pre>
    </div>
  </div>

</mat-dialog-content>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
   
    <button mat-button color="basic" (click)="close()"> Cancel </button>

  </mat-dialog-actions>
